import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { ReactSortable } from 'react-sortablejs';
import Icon from '../../elementals/icon';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const itemArrayPropType = PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.node,
    value: PropTypes.string,
}).isRequired);
const CustomContainer = forwardRef(({ children, className, id }, ref) => (_jsx("div", { ref: ref, className: className, "data-elm-id": id, children: children })));
CustomContainer.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    id: PropTypes.string,
};
const defaultOptionRenderer = option => option && (_jsxs("div", { "data-id": option.value, "data-elm-id": 'item', className: cx('item'), children: [_jsx(Icon, { "data-elm-id": 'move_item', name: 'up-down', iconStyle: 'solid', color: 'grayMedium', hoverColor: 'error', className: cx('icon-button') }), option.text] }, option.value));
const SortableList = ({ list = [], canSort, elmId, onChange, captureListRef, optionRenderer = defaultOptionRenderer, showAsGrid = false, }) => (_jsx(ReactSortable, { className: cx('block-list', { grid: showAsGrid }, { empty: list.length === 0 }), id: elmId, tag: CustomContainer, ref: captureListRef, sort: canSort, animation: 150, group: {
        name: 'shared',
        pull: true,
        put: true,
    }, setList: onChange, list: list, children: list.map(optionRenderer) }));
SortableList.propTypes = {
    list: itemArrayPropType,
    canSort: PropTypes.bool.isRequired,
    elmId: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    captureListRef: PropTypes.func,
    optionRenderer: PropTypes.func,
    showAsGrid: PropTypes.bool,
};
export default SortableList;
//# sourceMappingURL=index.js.map